import type { ReportSort, TableReportType } from '~/types/report-preview'
import type { ColumnKey } from '~/utils/reports/columns'

export type ReportWindowMode = 'range' | 'instant'

export interface ReportPreviewPreset {
  defaultSort: ReportSort[]
  windowMode: ReportWindowMode
  sortable: boolean
  hiddenKeys: ColumnKey[]
}

export const PREVIEW_PAGE_SIZE = 100

const HIDDEN_KEYS: ColumnKey[] = ['author']

export const REPORT_PREVIEW_PRESETS: Record<TableReportType, ReportPreviewPreset> = {
  alert: {
    defaultSort: [{ key: 'date', dir: 'desc' }],
    windowMode: 'range',
    sortable: true,
    hiddenKeys: HIDDEN_KEYS
  },
  'state-assets-log': {
    defaultSort: [{ key: 'last_communication', dir: 'desc' }],
    windowMode: 'instant',
    sortable: true,
    hiddenKeys: HIDDEN_KEYS
  },
  usage: {
    defaultSort: [{ key: 'serial_number', dir: 'asc' }],
    windowMode: 'range',
    sortable: true,
    hiddenKeys: HIDDEN_KEYS
  },
  'assets-registry': {
    defaultSort: [{ key: 'date', dir: 'desc' }],
    windowMode: 'range',
    sortable: true,
    hiddenKeys: HIDDEN_KEYS
  },
  'user-log': {
    defaultSort: [{ key: 'date', dir: 'desc' }],
    windowMode: 'range',
    sortable: true,
    hiddenKeys: HIDDEN_KEYS
  }
}

export const getReportPreviewPreset = (type: TableReportType): ReportPreviewPreset => REPORT_PREVIEW_PRESETS[type]
